import React from 'react'
import { Pressable, Text, View } from 'react-native'

import { IMAGE } from '@ui-kit/assets/images/index.native'
import Icon from '@ui-kit/components/Icon'
import { tag } from '@ui-kit/components/Tag/styles'
import type { TagType } from '@ui-kit/types'

import type { Props } from './types'

const INFO_ICON_MAP: Record<TagType, 'InfoIconNewWhite_16' | 'InfoIconNew_16'> = {
  successPrimary: 'InfoIconNewWhite_16',
  successSecondary: 'InfoIconNew_16',
  promo: 'InfoIconNew_16',
  infoPrimary: 'InfoIconNew_16',
  infoSecondary: 'InfoIconNew_16',
  inverted: 'InfoIconNewWhite_16',
}

const Tag = (props: Props): JSX.Element => {
  const isPressable = Boolean(props.onPress)
  const { container, text } = tag({ interactive: isPressable, type: props.type })
  const ComponentWrapper = isPressable ? Pressable : View
  const infoIcon = props.type ? INFO_ICON_MAP[props.type] : 'InfoIconNewWhite_16'

  return (
    <ComponentWrapper className={container()} onPress={props.onPress}>
      <Text className={text()}>{props.label}</Text>
      {isPressable ? <Icon imgSrc={IMAGE.icons.xsmall[infoIcon]} /> : null}
    </ComponentWrapper>
  )
}

export default Tag
